import { Component, OnInit } from '@angular/core';
import { FormService } from '../form.service';

@Component({
  selector: 'hc-support-icons',
  templateUrl: './support-icons.component.html'
})
export class SupportIconsComponent implements OnInit {

  constructor(
    private form : FormService
  ) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// L:/Vodafone/Happy Check/dev/vodhappycheck/src/app/support-icons/support-icons.component.ts